module.exports = __webpack_public_path__ + "76652221b17be62f9f379508b5509ced.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos/marc-amalia-cut.mp4
 ** module id = 352
 ** module chunks = 0
 **/